import { IVeriTableHeader, IVeriTableRow, IVeriTableRowCell } from "@directives/_veri/veriTable/veriTable.component";
import { VeriTableService } from "@directives/_veri/veriTable/veriTable.service";
import { ReportTypesNavLabels } from "@reports/enums/ReportTypesNavLabels";
import { TranslationService } from "@services/translation.service";
import { VeriDate } from "@services/veriDate.service";
import * as angular from "angular";
import { DynamicReportService } from "../../_services/dynamicReports.service";
import { IColumnHeader } from "../../models/IColumnHeader";
import { IReportHistory } from "../../models/IDynamicReportLog";
import { IReportDefinition } from "../../models/IReportDefinition";
import "./reportBuilderList.scss";

export interface IComponentBindings {
}

class ComponentController implements angular.IComponentController, IComponentBindings {

    loading = false;
    reportTypeHeaders: IColumnHeader[] = [];

    tableHeaders: IVeriTableHeader[] = [];
    tableRows: IVeriTableRow<IReportDefinition>[] = [];

    reportDefinitions: IReportDefinition[];
    reportLogs: IReportHistory[];
    reportCounts: number[];

    selectedReport: IReportDefinition;
    showReportBuilder = false;

    static $inject = ["$q", "dynamicReportService", "veriTableService", "veriDate", "translationService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly reportService: DynamicReportService,
        private readonly veriTableService: VeriTableService,
        private readonly veriDate: VeriDate,
        private readonly translationService: TranslationService) {
    }

    $onInit(): void {
        this.loadData();
        this.createTableHeaders();
    }

    createNewReport() {
        this.showReportBuilder = true;
    }

    onReportSelected(report: IReportDefinition) {
        this.showReportBuilder = true;
        this.selectedReport = report;
    }

    onReportBuilderClose(refresh = false) {
        this.selectedReport = null;
        this.showReportBuilder = false;

        if (refresh) {
            this.loadData(true);
        }
    }

    // --------------------

    private createTableHeaders() {
        this.tableHeaders = [
            { title: this.translationService.t("Reports.ReportName"), sortable: true },
            { title: this.translationService.t("Reports.ReportType"), width: 120, sortable: true },
            this.veriTableService.createDateTimeHeader(this.translationService.t("Reports.LastRan")),
        ];
    }

    private loadData(invalidateCache = false) {
        this.loading = true;

        const definitionPromise = this.reportService.getReports(invalidateCache);
        const historyPromise = this.reportService.getLatestReportHistory(invalidateCache);
        const countsPromise = this.reportService.getLogCounts(invalidateCache);

        this.$q.all([definitionPromise, historyPromise, countsPromise])
            .then(([definitions, logs, counts]) => {
                this.reportDefinitions = definitions;
                this.reportLogs = logs;
                this.reportCounts = counts;

                this.createTableRows();
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private createTableRows() {
        //console.log("createTableRows", this.reportDefinitions);
        this.tableRows = this.veriTableService.createTableRowsWithCells<IReportDefinition>(this.reportDefinitions, data => this.createTableRowCells(data));
    }

    private createTableRowCells(data: IReportDefinition): IVeriTableRowCell[] {
        var latestLog = this.reportLogs.find(r => r.ReportDefinitionId == data.Id);

        var lastRunTimestamp = null;
        var lastRunFormattedTimestamp = "";

        if (latestLog) {
            lastRunTimestamp = latestLog.CreatedTime as any;
            lastRunFormattedTimestamp = this.veriDate.formatDate(latestLog.CreatedTime);
        }

        return [
            { contents: data.Title },
            { contents: ReportTypesNavLabels[data.reportNavType] },
            { contents: lastRunFormattedTimestamp, sortData: lastRunTimestamp },
        ];
    }
}

export class ReportBuilderListComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
        };

        this.controller = ComponentController;
        this.template = require("./reportBuilderList.html");
    }
}
